

function About() {
  return (
    <>
      <div className="about5-scetion-area section-padding5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about5-images">
                <img
                  src="/assets/images/sectionimg/Artboard 1.webp"
                  alt=""
                  className="about5ims"
                />
                <img
                  src="/assets/images/elementor/elementor17.png"
                  alt=""
                  className="elementor-9 keyframe3"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="abou-5textarea5">
                <span className="font-16 font-outfit weight-500 lineh-16 color36 d-inline-block consultingspan margin-b20">
                  About Us
                </span>
                <h1 className="font-outfit font-44 lineh-52 color37 weight-600 margin-b20">
                  ETIHAD BUSINESS AND MANAGEMENT CONSULTANCY&nbsp; LLC
                </h1>
                <p
                  className="font-ks font-16 lineh-26 weight-500 color-30"
                  style={{ textAlign: "justify" }}
                >
                  Welcome to Etihad Business and Management Consultancy LLC
                  (EBMC), where our dedicated team of seasoned professionals
                  excels in delivering tailored excellence across a spectrum of
                  services, including Accounting, Auditing, Taxation, AML
                  Compliance, and more. At EBMC, our success is anchored in core
                  values encapsulated in eight pillars: quality, honesty,
                  integrity, openness, availability, reliability, responsiveness,
                  and pro-activeness. With a focus on precision and client-centric
                  service, our highly experienced team is ready to navigate the
                  complexities of modern business environments, ensuring your
                  financial management, auditing, tax planning, and AML compliance
                  needs are met with unparalleled expertise. Join us on a journey
                  of success, where your business objectives become our mission,
                  forging a path towards prosperity.
                </p>
                <div className="form5-srea">
                  <a rel="noreferrer" 
                    href="https://wa.link/o4ztme"
                    target="_blank"
                    className="theme6-btn6 theme-btn6  bakgrnd5 font-ks lineh-16 weight-700 color font-16"
                  >
                    Schedule a Consultation{" "}
                    <span>
                      <i className="fa-solid fa-arrow-right" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
